import classnames from 'classnames';
import HeartFilled from 'components/icons/HeartFilled';
import HeartOpen from 'components/icons/HeartOpen';
import React from 'react';

import CSS from './FavoritesButton.module.scss';

export interface FavoritesButtonPresentationalProps {
  isFavorite?: boolean;
  variant?: 'default' | 'pink';
  disabled?: boolean;
  className?: string;
  label?: string;
  onClick?: (event: React.MouseEvent) => void;
}

export const FavoritesButtonPresentational = ({
  isFavorite = false,
  variant = 'default',
  disabled = false,
  className,
  label,
  onClick,
}: FavoritesButtonPresentationalProps) => {
  const ariaLabel =
    label ?? (isFavorite ? 'Remove from favorites' : 'Add to favorites');

  return (
    <button
      type="button"
      className={classnames(CSS.FavoritesButton, className)}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-pressed={isFavorite}
      onClick={onClick}
    >
      <div className={CSS.FavoritesInner}>
        {isFavorite ? (
          <HeartFilled
            width={24}
            height={22}
            className={classnames(CSS.HeartFilled, CSS.Heart, {
              [CSS.HeartPink]: variant === 'pink',
            })}
          />
        ) : (
          <>
            <HeartOpen
              width={24}
              height={22}
              className={classnames(CSS.Heart, {
                [CSS.HeartPink]: variant === 'pink',
              })}
            />
            <HeartFilled
              width={22}
              height={20}
              className={CSS.HeartBackground}
            />
          </>
        )}
      </div>
    </button>
  );
};
